<template>
  <div>
    <modal centered :show.sync="localOpen" id="addAudiance" bodyClasses="create-campaign-modal-body"
      footerClasses="border-top p-2">
      <div slot="header"><span class="p-3 d-block"></span></div>
      <div class="pb-3 w-100 d-flex align-items-center justify-content-between col-sm-12 col-md-12 col-lg-12">
        <h3 class="title title-up m-0" style="color: #222a42 !important;">
          Media Storage
        </h3>
        <div class="d-flex align-items-center" style="gap: 8px;">
          <el-upload class="audiance-upload" accept="image/jpeg,image/png,image/gif" :auto-upload="false"
            :show-file-list="false" :thumbnail-mode="false" :on-preview="handlePreview"
            :on-remove="handleRemove" :file-list="fileList" :on-error="handleError" :on-change="handleChange">
            <el-button type="primary" icon="el-icon-upload2">Upload Media</el-button>
          </el-upload>
          <el-dropdown trigger="click">
            <span class="menu-drop-anchor">
              <el-button icon="el-icon-more"></el-button>

            </span>
            <el-dropdown-menu slot="dropdown">
              <div @click.stop="">
                <div class="d-flex align-items-center text-dark px-3" style="gap: 12px; font-size: 14px;">
                  <span><i class="fa-regular fa-cloud" style="margin-right: 4px;"></i>Storage Used</span>
                  <span>{{ mediaStorage }}</span>

                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 d-flex align-items-end mt-4" style="gap:20px">
        <div class="w-25">
          <label>{{ CompanyNamedisabled ? "Client" : "Select Client" }}</label>
          <el-select class="select__form__client w-100" size="large" placeholder="Select Client Name"
            v-model="selectedCompany" :disabled="CompanyNamedisabled" @change="onCompanyChange(selectedCompany)">
            <el-option v-for="option in companyList" :value="option.id" :label="option.company_name" :key="option.id">
            </el-option>
          </el-select>
        </div>
        <div class="w-25">
          <el-input placeholder="Search Media" prefix-icon="el-icon-search" v-model="searchQuery">
          </el-input>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
        <div class="d-flex align-items-center justify-content-between mb-2" style="height: 41px;">
          <span class="font-weight-600 text-dark" style="font-size: 14px;">Files</span>
          <div v-if="selectedItems.length">
            <el-button round @click="selectedItems = []" icon="el-icon-close">{{ selectedItems.length }}
              Selected</el-button>
            <el-button type="text" icon="el-icon-download" style="color: #000000; font-size: 16px;" :disabled="!selectedItems.length" @click="downloadSelected"></el-button>
            <el-button type="text" icon="el-icon-delete" style="color: #000000; font-size: 16px;" @click="handleDelete"></el-button>
          </div>
        </div>
        <!-- Media Collection -->
        <div class="media-collection-wrapper">
          <div class="media-collection-grid">
            <template v-if="filteredMediaData.length > 0">
              <media-item 
                v-for="item in filteredMediaData" 
                :item="item" 
                :selectedItems="selectedItems" 
                :key="item.id" 
                :isDeleting="deletingIds.includes(item.id)"
                @select="selectItem(item)">
              </media-item>
            </template>
            <template v-else>
              <div class="no-media-message" style="grid-column: 1 / -1; text-align:center; padding:20px; color:#666;">
                No media found.
              </div>
            </template>
          </div>
        </div>
      </div>

      <template slot="footer">
        <div class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" style="gap:8px">
          <div style="font-size: 14px;">
            <span><strong>Note: </strong>Only .jpg, .png or .gif formats supported for display ad</span></br>
            <span>Supported dimentions are 250x250, 300x250, 300x600, 970x250, 320x100</span>
          </div>
          <div class="d-flex flex-row-reverse flex-wrap align-items-center" style="gap:8px">
            <base-button v-if="selectedItems.length" size="sm" :id="'btnSave'" style="height:40px" @click="addToCampaign">
              Add Media
            </base-button>
            <base-button @click="localOpen = false" simple size="sm" style="height:40px">
              Cancel
            </base-button>
          </div>

        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "src/components";
import {
  Select, Option, Upload, Button, Checkbox, Dropdown,
  DropdownMenu,
  DropdownItem,
} from "element-ui";
import { required } from "vee-validate/dist/rules";
import MediaItem from "./MediaItem.vue";
import { selection } from "d3";
import axios from 'axios';
import { mapActions } from "vuex/dist/vuex.common.js";
import { downloadMediaBackground } from '../../helpers/downloadFile'
export default {
  components: {
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    MediaItem
  },
  data() {
    return {
      hover: false,
      mediaName: "",
      selectedCompany: "",
      fileList: [],
      isAggreed: false,
      selectedItems: [],
      searchQuery: "",
      allowedDims: [
        { w: 250, h: 250 },
        { w: 300, h: 250 },
        { w: 300, h: 600 },
        { w: 970, h: 250 },
        { w: 320, h: 100 },
      ],

      mediaData: [
        // {
        //   id: "1",
        //   date: "2016-05-03",
        //   name: "Tom.png",
        //   size: "150KB",
        //   dimensions: "250 x 250",
        //   media:
        //     "https://emmbetaspaces.nyc3.cdn.digitaloceanspaces.com/users/profile/_profilephoto_143_0ba5e36a5d23ece40104b38af3298524.png"
        // },
        // {
        //   id: "2",
        //   date: "2016-05-03",
        //   name: "medial_2.png",
        //   size: "150KB",
        //   dimensions: "300 x 250",
        //   media:
        //     "https://emmbetaspaces.nyc3.cdn.digitaloceanspaces.com/users/profile/_profilephoto_143_0ba5e36a5d23ece40104b38af3298524.png"
        // },
        // {
        //   id: "3",
        //   date: "2016-05-03",
        //   name: "media3.png",
        //   size: "150KB",
        //   dimensions: "300 x 600",
        //   media:
        //     "https://emmbetaspaces.nyc3.cdn.digitaloceanspaces.com/users/profile/_profilephoto_143_0ba5e36a5d23ece40104b38af3298524.png"
        // },
        // {
        //   id: "4",
        //   date: "2016-05-03",
        //   name: "media4.png",
        //   size: "150KB",
        //   dimensions: "970 x 250",
        //   media:
        //     "https://emmbetaspaces.nyc3.cdn.digitaloceanspaces.com/users/profile/_profilephoto_143_0ba5e36a5d23ece40104b38af3298524.png"
        // },
        // {
        //   id: "5",
        //   date: "2016-05-03",
        //   name: "media5.png",
        //   size: "150KB",
        //   dimensions: "320 x 100",
        //   media:
        //     "https://emmbetaspaces.nyc3.cdn.digitaloceanspaces.com/users/profile/_profilephoto_143_0ba5e36a5d23ece40104b38af3298524.png"
        // },
        // {
        //   id: "6",
        //   date: "2016-05-03",
        //   name: "media6.png",
        //   size: "150KB",
        //   dimensions: "320 x 100",
        //   media:
        //     "https://emmbetaspaces.nyc3.cdn.digitaloceanspaces.com/users/profile/_profilephoto_143_0ba5e36a5d23ece40104b38af3298524.png"
        // }
      ],
      storageUsedKB: 0,
      storageLimitKB: 102400, // 100 MB in KB
      filteredMediaData: [],
      deletingIds: []
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    CompanyNamedisabled: {
      type: Boolean,
      required: true
    },
    companySelected: {
      type: String,
      required: true
    },
    companyList: {
      type: Array,
      required: true
    },
  },
  computed: {
    localOpen: {
      get() {
        this.selectedCompany = this.companySelected;
        this.selectedItems = [];
        this.getMedia()
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    storageUsedMB() {
      return (this.storageUsedKB / 1024).toFixed(2); // convert KB -> MB
    },
    storageLimitMB() {
      return (this.storageLimitKB / 1024).toFixed(0);
    },
    mediaStorage() {
      return `${this.storageUsedMB}MB/${this.storageLimitMB}MB`;
    },
  },
  watch: {
    searchQuery(newQuery) {
      this.filterMedia(newQuery);
    }
  },
  mounted() {
    this.selectedCompany = this.companySelected;
    this.selectedItems = [];
  },
  methods: {
    ... mapActions(['SimplifiGetMedia','GetDownloadMediaToken']),
    onCompanyChange(_companySelected){
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.companyList[i].id == _companySelected) {
          this.companySelected = this.companyList[
            i
          ].company_name;
        }
      }
      this.getMedia()
    },
    async getMedia(userId){     
      const selectedCompanyItem = this.companyList.find(item => item.company_name == this.selectedCompany);
      const user_id = selectedCompanyItem ? selectedCompanyItem.id : null;         
      const payloadGetMedia = {
        user_id: userId || user_id,
      }
      const response = await this.SimplifiGetMedia({ data: payloadGetMedia });
      
      if (response.result == 'success') {
        this.mediaData = response.media
        this.storageUsedKB = response.occupied_storage
      }else{
        this.mediaData = []
      }
      this.filterMedia(this.searchQuery);
      return this.mediaData;  
    },
    filterMedia(query) {
      if (!query) {
        this.filteredMediaData = [...this.mediaData];
      } else {
        const lowerQuery = query.toLowerCase();
        this.filteredMediaData = this.mediaData.filter(item =>
          item.name.toLowerCase().includes(lowerQuery)
        );
      }
    },
    handleRemove() { },
    handlePreview() { },
    noopUpload() {
      // Required by Element UI; can be empty
      return;
    },
    handleChange(file) {
      const selectedCompanyItem = this.companyList.find(item => item.company_name == this.selectedCompany);
      const user_id = selectedCompanyItem ? selectedCompanyItem.id : null;
      if(!user_id) {
        this.$notify({ 
          type: 'danger', 
          message: 'user id not found', 
          icon: 'fas fa-bug'
        });
        return;
      }
      const reader = new FileReader();
      reader.onload = e => {
        const img = new Image();
        img.onload = () => {
          const { width, height } = img;
          const isValid = this.allowedDims.some(d => d.w === width && d.h === height);
          if (!isValid) {
            this.$notify({
              type: 'primary',
              message: `Invalid dimension ${width}×${height}.<br> Valid dimensions are 250x250, 300x250, 300x600, 970x250, 320x100`,
              icon: 'fas fa-bug'
            });
            const idx = this.fileList.findIndex(f => f.uid === file.uid);
            if (idx !== -1) this.fileList.splice(idx, 1);
            return;
          }

          const formData = new FormData();
          formData.append('user_id', user_id);
          formData.append('file', file.raw);

          this.isUploadAudiance = true;

          axios.post(process.env.VUE_APP_APISERVER_URL + '/api/media/upload', formData)
            .then(() => {
              this.isUploadAudiance = false;
              this.getMedia()
              this.$notify({
                type: 'success',
                message: 'Upload successful!',
                icon: 'fas fa-check-circle'
              });
            })
            .catch(error => {
              this.isUploadAudiance = false;
              const message = error.response.data.message || 'Something went wrong, please try again';
              this.$notify({
                type: 'danger',
                message,
                icon: 'fas fa-exclamation-triangle'
              });
            });
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file.raw);
    },
    async handleDelete() {
      if (!this.selectedItems.length) return;
      const selectedIds = this.selectedItems.map(item => item.id);
      this.deletingIds = [...this.deletingIds, ...selectedIds];
      try {
        const formData = new FormData();
        formData.append('media_ids', selectedIds);
        await axios.post(`${process.env.VUE_APP_APISERVER_URL}/api/media/delete`, formData);
        await this.getMedia();
        this.$notify({
          type: 'success',
          message: 'Selected media deleted successfully!',
          icon: 'fas fa-check-circle'
        });
        this.selectedItems = [];
      } catch (error) {
        const message = error.response.data.message || 'Failed to delete media, please try again';
        this.$notify({
          type: 'danger',
          message,
          icon: 'fas fa-exclamation-triangle'
        });
      } finally {
        this.deletingIds = this.deletingIds.filter(id => !selectedIds.includes(id));
      }
    },
    async downloadSelected() {
        if (!this.selectedItems.length) return;

        const media_ids = this.selectedItems.map(item => item.id);
        const payloadGetdownloadMediaToken = {
          media_ids,
        }
        const response = await this.GetDownloadMediaToken({ data: payloadGetdownloadMediaToken });
        if (response.token) {
          try {
              const url = `${process.env.VUE_APP_DATASERVER_URL}/download-media/${response.token}`;

              const fileName = this.selectedItems.length === 1 
                  ? this.selectedItems[0].name
                  : 'selected-files.zip';
              downloadMediaBackground(url, fileName);
  
          } catch (err) {
              console.error("Failed to download:", err);
          }
        }else{
          this.$notify({
            type: 'danger',
            message: 'Failed to get download token, please try again',
            icon: 'fas fa-exclamation-triangle'
          });
        }
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleError(err, file) {
      console.error('Upload failed:', err, file);
    },
    selectItem(item) {
      const index = this.selectedItems.findIndex(i => i.id === item.id);
      if (index !== -1) {
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(item);
      }
      
    },
    addToCampaign(){
      this.$emit('selected-media', this.selectedItems);
    },
    removeItem() { }
  },
};
</script>

<style lang="scss">
.audiance-upload .el-upload-dragger {
  width: 100%;
}

.audiance-upload .el-upload {
  width: 100%;
}

.media-collection-wrapper {
  max-height: 490px;
  overflow-y: scroll;
}

.media-collection-grid {
  display: grid;
  margin-top: 16px;
  position: unset !important;
  gap: 1.5rem;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.rounded-lg {
  border-radius: 0.5rem;
}
</style>
